import { FC, useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { ReactComponent as SearchIcon } from '@/assets/icons/search-icon.svg';
import InputWithIcon, { InputWithIconProps } from '../InputWithIcon/InputWithIcon';

type InputSearchProps = InputWithIconProps & {
  value?: string | undefined;
  handleNameSearch: (value: string) => void;
  containerClassName?: string;
  // placeholder: string;
};
const InputSearch: FC<InputSearchProps> = ({
  value = '',
  handleNameSearch,
  fullWidth = false,
  placeholder,
  containerClassName = '',
}) => {
  const [queryString, setQueryString] = useState(value);
  const [debouncedQuery] = useDebounce(queryString, 500);

  useEffect(() => {
    handleNameSearch(debouncedQuery);
  }, [debouncedQuery]);

  return (
    <InputWithIcon
      icon={<SearchIcon />}
      placeholder={placeholder}
      value={queryString}
      fullWidth={fullWidth}
      onChange={(e) => setQueryString(e.target.value)}
      containerClassName={containerClassName}
    />
  );
};

export default InputSearch;
